import { useState, useEffect } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";

// PUBLIC davet landing: giris/kayit olmadan acilir. Kullanici urun secer -> bilgi+kart girer
// -> klasik SaaS: kayit + giris + davet indirimli (%30/980) abonelik baslar.
const PLAIN = { "Content-Type": "application/json" };

const ICONS = { english: "🇬🇧", kids: "🧒", german: "🇩🇪", spanish: "🇪🇸", french: "🇫🇷", ielts: "📘", toefl: "📕", yds: "🎯", yokdil: "🎯", kpss: "🎓" };
function iconFor(name) { const n = (name || "").toLowerCase(); for (const k in ICONS) if (n.includes(k)) return ICONS[k]; return "🎓"; }
function cleanName(name) { return (name || "").replace(/\s*Basic Paket\s*/i, "").replace(/\s*Paket\s*/i, "").trim() || name; }

// İNCELE butonu -> ilgili biyapayzeka.com urun sayfasi (yeni sekme). Eslesme p.name bot koduyla.
const PRODUCT_URLS = {
  "biENGLISH": "https://biyapayzeka.com/product/bienglish-yapayzeka-ile-ingilizce-egitim-paketi-2/",
  "biKIDS": "https://biyapayzeka.com/product/bikids-yapayzeka-ile-cocuklara-ozel-dil-egitim-paketi/",
  "biGERMAN": "https://biyapayzeka.com/product/bi-german-uzman-yapay-zeka-egitim-paketi/",
  "biSPANISH": "https://biyapayzeka.com/product/bi-spanish-uzman-yapay-zeka-egitim-paketi/",
  "biIELTS": "https://biyapayzeka.com/product/bi-ielts-sinav-hazirlik-uzman-yapay-zeka-egitim-paketi/",
  "biTOEFL": "https://biyapayzeka.com/product/bi-toefl-sinav-hazirlik-uzman-yapay-zeka-egitim-paketi/",
  "biYDS": "https://biyapayzeka.com/product/bi-yds-sinav-hazirlik-uzman-yapay-zeka-egitim-paketi/",
  "biKPSS": "https://biyapayzeka.com/product/bikpss-uzman-yapay-zeka-egitim-paketi/",
  "biFRENCH": "https://biyapayzeka.com/product/bifrench-uzman-yapay-zeka-ile-fransizca-egitim-paketi-2/",
  "biARABIC": "https://biyapayzeka.com/product/biarabic-yapayzeka-ile-arapca-egitim-paketi/",
  "biRUSSIAN": "https://biyapayzeka.com/product/birussian-uzman-yapay-zeka-egitim-paketi/",
  "biTURKISH": "https://biyapayzeka.com/product/biturkish-uzman-yapay-zeka-egitim-paketi/",
  "biPTE": "https://biyapayzeka.com/product/bi-pte-sinav-hazirlik-uzman-yapay-zeka-egitim-paketi/",
  "biLGS": "https://biyapayzeka.com/product/bilgs-uzman-yapay-zeka-egitim-paketi/",
  "biTYT-AYT": "https://biyapayzeka.com/product/bityt-ayt-uzman-yapay-zeka-egitim-paketi/",
  "biYÖKDİL": "https://biyapayzeka.com/product/bigokdil-uzman-yapay-zeka-egitim-paketi/",
};
const purlNorm = s => (s || "").toString().toLowerCase().replace(/İ/g, "i").replace(/I/g, "i").replace(/ı/g, "i").replace(/[\s-]/g, "");
function productUrlFor(name) { const n = purlNorm(name); for (const code in PRODUCT_URLS) { if (n.indexOf(purlNorm(code)) === 0) return PRODUCT_URLS[code]; } return null; }

export default function DavetFirsat() {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  const ref = params.ref || new URLSearchParams(location.search).get("ref") || "";

  const [pkgs, setPkgs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sel, setSel] = useState(null);
  const [screen, setScreen] = useState("offer"); // offer | pay | done
  const [form, setForm] = useState({ ad: "", email: "", tel: "", sifre: "" });
  const [card, setCard] = useState({ owner: "", number: "", exp: "", cvv: "" });
  const [consent, setConsent] = useState(true);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const r = await fetch("/api/packages", { headers: PLAIN }); // PUBLIC
        const d = await r.json();
        const list = Array.isArray(d) ? d : (Array.isArray(d?.data) ? d.data : []);
        const basics = list.filter(p => p.isActive !== false && Number(p.price) > 0 && /basic/i.test(p.name || ""));
        // SIRALAMA: ilk 8 = /ucretsizdene sirasi (4 dil -> 4 sinav), sonra kalan diller -> kalan sinavlar
        const ORDER = ["biENGLISH","biKIDS","biGERMAN","biSPANISH","biIELTS","biTOEFL","biYDS","biKPSS","biFRENCH","biARABIC","biRUSSIAN","biTURKISH","biPTE","biLGS","biTYT-AYT","biYÖKDİL"];
        const onorm = s => (s || "").toString().toLowerCase().replace(/İ/g, "i").replace(/I/g, "i").replace(/ı/g, "i").replace(/[\s-]/g, "");
        const orank = p => { const n = onorm(p.name); const i = ORDER.findIndex(c => n.indexOf(onorm(c)) === 0); return i === -1 ? 999 : i; };
        basics.sort((a, b) => orank(a) - orank(b));
        setPkgs(basics);
      } catch { setErr("Egitimler yuklenemedi"); }
      finally { setLoading(false); }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const disc = (price) => Math.round((Number(price) || 0) * 0.7);
  const fmt = (n) => (Number(n) || 0).toLocaleString("tr-TR");

  const pick = (p) => { setSel(p); setScreen("pay"); setErr(""); window.scrollTo(0, 0); };
  const goOffer = () => { setScreen("offer"); setErr(""); window.scrollTo(0, 0); };

  async function jpost(url, body, token) {
    const headers = token ? { ...PLAIN, Authorization: "Bearer " + token } : PLAIN;
    const r = await fetch(url, { method: "POST", headers, body: JSON.stringify(body) });
    let d = {}; try { d = await r.json(); } catch {}
    return { ok: r.ok, status: r.status, d };
  }

  const start = async () => {
    if (!sel) return;
    setErr("");
    // 1) bilgi dogrula
    const parts = form.ad.trim().split(/\s+/);
    const name = parts[0] || ""; const surname = parts.slice(1).join(" ");
    if (!name || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(form.email.trim()) || form.tel.replace(/\D/g, "").length < 10 || form.sifre.length < 6) {
      setErr("Lutfen ad, gecerli e-posta, telefon ve en az 6 haneli sifre gir."); return;
    }
    // 2) kart dogrula
    const digits = card.number.replace(/\D/g, "");
    const ex = card.exp.replace(/\D/g, ""); const mm = ex.slice(0, 2); const yy = ex.slice(2);
    if (!card.owner.trim() || digits.length < 15 || mm.length < 2 || yy.length < 2 || card.cvv.length < 3) { setErr("Lutfen kart bilgilerini eksiksiz gir."); return; }
    if (!consent) { setErr("Devam etmek icin onay kutusunu isaretle."); return; }

    setBusy(true);
    try {
      const email = form.email.trim().toLowerCase();
      // 3) KAYIT (varsa atla)
      const reg = await jpost("/api/platform/auth/register", { name, surname, email, password: form.sifre, phone: form.tel.trim() });
      // 4) GIRIS (token al)
      const log = await jpost("/api/platform/auth/login", { emailOrUsername: email, password: form.sifre });
      const tokenV = log.d.token || log.d.accessToken || (log.d.data && log.d.data.token) || "";
      if (!tokenV) {
        setErr(reg.ok ? "Giris yapilamadi, tekrar dene." : (reg.d.message || "Bu e-posta zaten kayitli olabilir; sifreni kontrol et."));
        setBusy(false); return;
      }
      try { localStorage.setItem("biyz_token", tokenV); if (log.d.user) localStorage.setItem("biyz_user", JSON.stringify(log.d.user)); } catch {}
      // 5) DAVET bagla (varsa) — davet edenin sayaci + referredBy
      if (ref) { try { await jpost("/api/platform/gamification/referral/apply", { code: ref }, tokenV); } catch {} }
      // 6) ABONELIK BASLAT — davet %30 (DAVET30) + 7 gun ucretsiz
      const sub = await jpost("/api/payments/esnekpos/recurring/start", {
        packageId: sel._id, trialDays: 7, campaignCode: "DAVET30",
        card: { CC_OWNER: card.owner.trim(), CC_NUMBER: digits, EXP_MONTH: mm, EXP_YEAR: yy.length === 2 ? ("20" + yy) : yy, CC_CVV: card.cvv },
      }, tokenV);
      if (!sub.ok || !sub.d.ok) { setErr(sub.d.error === "recurring_init_failed" ? (sub.d.detail?.message || "Odeme reddedildi, kartini kontrol et") : (sub.d.error || "Abonelik baslatilamadi")); setBusy(false); return; }
      setScreen("done"); window.scrollTo(0, 0);
    } catch { setErr("Sunucuya baglanilamadi"); }
    finally { setBusy(false); }
  };

  return (
    <div style={{ minHeight: "100vh", background: "#eef2f7" }}>
      <style>{CSS}</style>

      {screen === "offer" && (
        <>
          <header className="df-header">
            <div className="df-wrap">
              <div className="df-brand"><span className="df-lbadge">bi</span><span className="df-word"><span className="df-w1">bi</span><span className="df-w2">YAPAYZEKA</span></span></div>
              <div className="df-chip">🎁 Davetle geldin — sana özel</div>
              <div className="df-hello">Sana Özel Bir Fırsatımız Var
                <small><b>7 gün ücretsiz dene</b> — beğenirsen sana özel <b>%30 indirimle</b> devam et</small>
              </div>
            </div>
          </header>
          <div className="df-wrap">
            <div className="df-offer">
              Seçtiğin eğitimde <b>7 GÜN ÜCRETSİZ</b> 🎁 &nbsp;Beğenirsen sana özel <b>%30 indirimle</b> devam et — <b>istediğin an tek tıkla iptal.</b>
              <div className="df-price-line">Sadece <span className="df-oldbig">1.400 ₺</span><span className="df-amt">980 ₺/ay</span></div>
              <div className="df-tiny">%30 indirim hesabına <b>otomatik tanımlı</b> — kod girmene gerek yok · 7 gün boyunca hiçbir ücret alınmaz</div>
            </div>
            <div className="df-sec-title">Hangi eğitimle başlamak istersin?</div>
            <div className="df-sec-sub">Sana en uygun olanı seç — gerisini biz hallederiz</div>
            {loading ? <div className="df-loading">Yükleniyor…</div> : (
              <div className="df-grid">
                {pkgs.map(p => (
                  <div className="df-card" key={p._id} onClick={() => pick(p)}>
                    <div className="df-badge">7 GÜN BEDAVA</div>
                    <div className="df-ico">{iconFor(p.name)}</div>
                    <h3>{cleanName(p.name)}</h3>
                    <p>{p.description || "Seninle konuşarak öğreten Uzman Yapay Zeka Öğretmenin."}</p>
                    <div className="df-cprice"><span className="df-old">{fmt(p.price)}₺</span><br /><span className="df-new">{fmt(disc(p.price))}₺</span> <span className="df-per">/ay</span></div>
                    {productUrlFor(p.name) && (
                      <a className="df-review" href={productUrlFor(p.name)} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()}>İNCELE</a>
                    )}
                    <button className="df-pick">Hemen Başla →</button>
                  </div>
                ))}
              </div>
            )}
            {err && <div className="df-err">{err}</div>}
          </div>
        </>
      )}

      {screen === "pay" && sel && (
        <div className="df-wrap">
          <div className="df-panel">
            <button className="df-back" onClick={goOffer}>← Geri, başka eğitim seç</button>
            <div className="df-sel-head">
              <div className="df-ico">{iconFor(sel.name)}</div>
              <div><h2>{cleanName(sel.name)} — Elit Üyelik</h2><div className="df-muted">Davete özel %30 indirim uygulandı</div></div>
            </div>
            <div className="df-green">🎁 Davet indirimin uygulandı — %30 avantaj senin!</div>
            <div className="df-pricebox">
              <div className="df-row"><span>İlk 7 gün</span><span className="df-free">ÜCRETSİZ — 0 ₺</span></div>
              <div className="df-row"><span>Normal aylık</span><span className="df-oldp">{fmt(sel.price)} ₺</span></div>
              <div className="df-row"><span className="df-big">7 gün sonra sana özel</span><span className="df-big">{fmt(disc(sel.price))} ₺/ay <small style={{ color: "#16a34a" }}>(%30 indirim)</small></span></div>
            </div>

            <div className="df-ftitle">Hesap Bilgilerin</div>
            <div className="df-form">
              <div className="df-full"><label>Ad Soyad</label><input value={form.ad} onChange={e => setForm({ ...form, ad: e.target.value })} placeholder="Ad Soyad" /></div>
              <div className="df-full"><label>E-posta</label><input value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} placeholder="ornek@eposta.com" inputMode="email" /></div>
              <div><label>Telefon</label><input value={form.tel} onChange={e => setForm({ ...form, tel: e.target.value })} placeholder="05xx xxx xx xx" inputMode="numeric" /></div>
              <div><label>Şifre (min 6)</label><input type="password" value={form.sifre} onChange={e => setForm({ ...form, sifre: e.target.value })} placeholder="••••••" /></div>
            </div>

            <div className="df-ftitle">Kart Bilgilerin</div>
            <div className="df-disclose">
              <b>Net bilgilendirme:</b> İlk 7 gün tamamen ücretsizdir, kartından <b>hiçbir tahsilat yapılmaz</b>.
              7. günün sonunda iptal etmezsen kartından <b>aylık {fmt(disc(sel.price))} ₺</b> çekilir. Aboneliğini panelinden <b>tek tıkla, istediğin an</b> iptal edebilirsin.
            </div>
            {err && <div className="df-err">{err}</div>}
            <div className="df-form">
              <div className="df-full"><label>Kart Üzerindeki İsim</label><input value={card.owner} onChange={e => setCard({ ...card, owner: e.target.value })} placeholder="Ad Soyad" /></div>
              <div className="df-full"><label>Kart Numarası</label><input value={card.number} onChange={e => setCard({ ...card, number: e.target.value })} placeholder="0000 0000 0000 0000" inputMode="numeric" /></div>
              <div><label>Son Kullanma (AA/YY)</label><input value={card.exp} onChange={e => setCard({ ...card, exp: e.target.value })} placeholder="AA/YY" /></div>
              <div><label>CVV</label><input value={card.cvv} onChange={e => setCard({ ...card, cvv: e.target.value })} placeholder="123" inputMode="numeric" /></div>
            </div>
            <label className="df-accept"><input type="checkbox" checked={consent} onChange={e => setConsent(e.target.checked)} /><span>7 gün ücretsiz deneme ve sonrasında <b>{fmt(disc(sel.price))} ₺/ay</b> otomatik yenileme koşullarını okudum, onaylıyorum.</span></label>
            <button className="df-start" disabled={busy} onClick={start}>{busy ? "İşleniyor…" : "7 Günlük Ücretsiz Denememi Başlat →"}</button>
            <div className="df-cancel-note">🔒 Güvenli ödeme · İlk 7 gün 0 ₺ · Tek tıkla iptal</div>
          </div>
        </div>
      )}

      {screen === "done" && sel && (
        <div className="df-wrap">
          <div className="df-ok">
            <div className="df-ok-big">🎉</div>
            <h2>Hoş geldin!</h2>
            <p><b>{cleanName(sel.name)}</b> 7 günlük ücretsiz denemen başladı. Hesabın oluşturuldu ve giriş yapıldı — kartından şu an hiçbir ücret alınmadı.</p>
            <button className="df-start" style={{ maxWidth: 320, margin: "0 auto" }} onClick={() => navigate("/chat")}>Eğitime Başla →</button>
          </div>
        </div>
      )}
    </div>
  );
}

const CSS = `
.df-wrap{max-width:920px;margin:0 auto;padding:0 16px}
.df-header{background:linear-gradient(135deg,#0d2a52,#1565c0);color:#fff;padding:26px 0 74px;text-align:center;border-radius:0 0 28px 28px}
.df-brand{display:flex;align-items:center;gap:12px;justify-content:center;margin:0 auto 10px}
.df-lbadge{width:46px;height:46px;border-radius:13px;background:linear-gradient(135deg,#9E86FB,#7C5CFC);color:#fff;font-weight:800;font-size:22px;display:flex;align-items:center;justify-content:center;box-shadow:0 4px 14px rgba(124,92,252,.42)}
.df-word{font-weight:800;font-size:27px;letter-spacing:.3px}.df-w1{color:#fff}.df-w2{background:linear-gradient(90deg,#7C5CFC,#3B6BFF);-webkit-background-clip:text;background-clip:text;color:transparent}
.df-chip{display:inline-block;background:rgba(255,255,255,.16);border:1px solid rgba(255,255,255,.35);color:#fff;font-size:14.5px;font-weight:700;padding:8px 18px;border-radius:22px;margin-bottom:8px}
.df-hello{margin-top:6px;font-size:30px;font-weight:800}
.df-hello small{display:block;font-size:15px;font-weight:500;opacity:.92;margin-top:6px}
.df-offer{background:#fff;border:2px dashed #1565c0;border-radius:16px;margin:-46px auto 6px;max-width:680px;padding:16px 18px;text-align:center;box-shadow:0 8px 30px rgba(13,42,82,.12)}
.df-offer b{color:#1565c0}
.df-price-line{font-size:18px;font-weight:800;color:#0d2a52;margin-top:8px}
.df-amt{color:#1565c0;white-space:nowrap}
.df-oldbig{color:#b4313b;text-decoration:line-through;font-size:.8em;margin-right:8px;font-weight:700}
.df-tiny{font-size:12.5px;color:#6b7785;margin-top:8px}
.df-sec-title{text-align:center;font-size:20px;font-weight:800;margin:26px 0 4px;color:#1a2233}
.df-sec-sub{text-align:center;color:#6b7785;font-size:14px;margin-bottom:18px}
.df-loading{text-align:center;color:#6b7785;padding:30px}
.df-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(210px,1fr));gap:14px;padding-bottom:34px}
.df-card{background:#fff;border:1px solid #e3e9f0;border-radius:16px;padding:16px;cursor:pointer;transition:.15s;position:relative;display:flex;flex-direction:column}
.df-card:hover{transform:translateY(-3px);box-shadow:0 10px 26px rgba(13,42,82,.14);border-color:#1e88e5}
.df-ico{font-size:30px}
.df-card h3{font-size:16px;margin:8px 0 2px;color:#1a2233}
.df-card p{font-size:12.5px;color:#6b7785;line-height:1.5}
.df-cprice{margin-top:auto;padding-top:12px;font-size:13px;line-height:1.7}
.df-old{color:#b4313b;text-decoration:line-through;margin-right:6px;font-size:12.5px}
.df-new{font-weight:800;color:#1a2233;font-size:19px}
.df-per{color:#6b7785;font-size:12px}
.df-badge{position:absolute;top:10px;right:10px;background:#e8f5e9;color:#16a34a;font-size:11px;font-weight:700;padding:2px 8px;border-radius:20px}
.df-pick{margin-top:10px;width:100%;border:0;background:#1565c0;color:#fff;font-weight:700;padding:10px;border-radius:10px;cursor:pointer;font-size:14px}
.df-pick:hover{background:#0f4fa0}
.df-review{display:block;box-sizing:border-box;text-align:center;text-decoration:none;margin-top:10px;width:100%;border:1.5px solid #1565c0;background:#fff;color:#1565c0;font-weight:700;padding:8px;border-radius:10px;font-size:13.5px;transition:.15s}
.df-review:hover{background:#1565c0;color:#fff}
.df-panel{background:#fff;border:1px solid #e3e9f0;border-radius:18px;padding:22px;margin:24px 0 40px;box-shadow:0 8px 30px rgba(13,42,82,.10)}
.df-back{background:none;border:0;color:#1565c0;cursor:pointer;font-size:13px;margin-bottom:8px}
.df-sel-head{display:flex;align-items:center;gap:12px;border-bottom:1px solid #e3e9f0;padding-bottom:14px;margin-bottom:14px}
.df-sel-head .df-ico{font-size:34px}
.df-sel-head h2{font-size:20px;color:#1a2233}
.df-muted{color:#6b7785;font-size:13px}
.df-green{background:linear-gradient(135deg,#065f46,#10b981);color:#fff;font-weight:800;font-size:13.5px;border-radius:12px;padding:12px 14px;margin-bottom:14px}
.df-pricebox{background:#f3f8ff;border:1px solid #cfe2fb;border-radius:14px;padding:16px;margin-bottom:16px}
.df-row{display:flex;justify-content:space-between;font-size:14px;padding:4px 0;color:#1a2233}
.df-big{font-size:17px;font-weight:800}
.df-free{color:#16a34a;font-weight:800}
.df-oldp{text-decoration:line-through;color:#b4313b}
.df-ftitle{font-weight:800;color:#0d2a52;font-size:15px;margin:6px 0 10px}
.df-disclose{font-size:12.5px;color:#5a6675;background:#fffaf0;border:1px solid #ffe7b3;border-radius:10px;padding:11px 13px;margin-bottom:14px}
.df-disclose b{color:#9a6a00}
.df-form{display:grid;grid-template-columns:1fr 1fr;gap:12px;margin-bottom:8px}
.df-form .df-full{grid-column:1/-1}
.df-form label{font-size:12.5px;color:#6b7785;display:block;margin-bottom:4px}
.df-form input{width:100%;padding:11px;border:1px solid #e3e9f0;border-radius:10px;font-size:14px;background:#fafcfe}
.df-accept{display:flex;gap:9px;align-items:flex-start;font-size:13px;margin:14px 0;color:#3a4757}
.df-accept input{width:auto;margin-top:3px}
.df-start{width:100%;border:0;background:linear-gradient(135deg,#1565c0,#1e88e5);color:#fff;font-weight:800;font-size:16px;padding:15px;border-radius:12px;cursor:pointer}
.df-start:hover{filter:brightness(1.05)}.df-start:disabled{opacity:.7;cursor:default}
.df-cancel-note{text-align:center;color:#6b7785;font-size:12px;margin-top:10px}
.df-err{background:#fdecef;border:1px solid #f5c2cd;color:#b4313b;border-radius:10px;padding:10px 13px;font-size:13px;margin:12px 0}
.df-ok{text-align:center;padding:56px 0}
.df-ok-big{font-size:54px}.df-ok h2{font-size:24px;margin:10px 0;color:#1a2233}
.df-ok p{color:#6b7785;max-width:460px;margin:0 auto 18px}
@media(max-width:560px){.df-hello{font-size:24px}.df-form{grid-template-columns:1fr}}
`;
